// notice: 今後このコンポーネントを直接利用せず、basicDialogコンポーネントやimageDialogコンポーネントを利用してください
import * as DialogPrimitive from '@radix-ui/react-dialog';
import React from 'react';
import styles from './index.module.scss';

export const DialogContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ children, ...props }, forwardedRef) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className={styles.Overlay} />
    <DialogPrimitive.Content
      className={styles.Content}
      {...props}
      ref={forwardedRef}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogTitle = DialogPrimitive.Title;
export const DialogDescription = DialogPrimitive.DialogDescription;
export const DialogClose = DialogPrimitive.DialogClose;
